import { Paginate } from '@nextiva/next-ui';
import cx from 'classnames';
import * as React from 'react';
import EntriesPerPage from '../../EntriesPerPage';
import PaginationStatus from '../../PaginationStatus';
import AddButton from './AddButton';
import Search from './Search';
import Styles from "./ListControlPanel.css";

function ListControlPanel(_a) {
  var DateRangePicker = _a.dateRangePicker,
      withDateRange = _a.withDateRange,
      onSearchChange = _a.onSearchChange,
      searchValue = _a.searchValue,
      withSearch = _a.withSearch,
      withAddButton = _a.withAddButton,
      withPerPage = _a.withPerPage,
      onAddButtonClick = _a.onAddButtonClick,
      onPerPageChange = _a.onPerPageChange,
      pagination = _a.pagination,
      withPagination = _a.withPagination,
      onPageChange = _a.onPageChange,
      addButtonText = _a.addButtonText,
      isLoading = _a.isLoading,
      buttonComponent = _a.buttonComponent;
  var pageCount = Math.ceil(pagination.totalItems / pagination.limit);
  var showPagination = withPagination && pageCount > 1;

  var DefaultButtonComponent = function DefaultButtonComponent() {
    return React.createElement(AddButton, {
      "data-test": "list-create-button",
      onClick: onAddButtonClick
    }, addButtonText);
  };

  var ButtonComponent = buttonComponent || DefaultButtonComponent;
  return React.createElement("div", {
    className: cx(Styles.controlPanel),
    "data-test": "list-control-panel"
  }, React.createElement("div", {
    className: Styles.mainBlock
  }, React.createElement("div", {
    className: Styles.leftBlock
  }, withPerPage && React.createElement(EntriesPerPage, {
    onChange: onPerPageChange,
    value: pagination.limit
  }), !isLoading && React.createElement(PaginationStatus, {
    pagination: pagination
  })), React.createElement("div", {
    className: Styles.rightBlock
  }, withSearch && React.createElement(Search, {
    onChange: onSearchChange,
    searchValue: searchValue
  }), showPagination && React.createElement(Paginate, {
    pageCount: pageCount,
    forcePage: Math.floor(pagination.offset / pagination.limit),
    onPageChange: onPageChange
  }), withAddButton && React.createElement(ButtonComponent, null), withDateRange && React.createElement(DateRangePicker, null))));
} // @ts-ignore


export default React.memo(ListControlPanel);